export {
  default as tennis,
  ReactComponent as Tennis,
} from '@assets/icons/features-and-amenities/tennis.svg'    
